
import { priceFormat, formatImgUrl, formatWareImgUrl, generateQR } from "@/utils/utils"
export default {
  name: "Dialog",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    url: {
      type: String,
      default: () => ""
    }
  },
  data() {
    return {
      showQRcodeSrc: "",
      showQr: false
    }
  },

  computed: {
    visible() {
      return this.value
    }
  },
  watch: {
    url: {
      handler(val) {
        generateQR(val).then(src => {
          this.showQRcodeSrc = src
        })
      }
    }
  },
  mounted() {},
  methods: {
    close() {
      this.$emit("closeDialog", false)
    },
    goStore(val) {
      if (val === "apple") {
        window.open("https://apps.apple.com/app/id6680157469")
      } else {
        window.open("https://play.google.com/store/apps/details?id=com.rtahk.seveneleven")
      }
    }
  }
}
